import { useMissionsTranslation } from '../../../../../ui/hooks';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const ToolbarVolunteer = ({ participantNumber, totalRequiredParticipantNumber }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: { pb: 2, display: 'flex', alignItems: 'center', gap: 1 }, "data-test": 'shift-roster-toolbar' },
        React.createElement(SupervisorAccountOutlinedIcon, { sx: { color: (theme) => theme.palette.grey['700'] } }),
        React.createElement(Typography, { variant: 'subtitle2', sx: { color: (theme) => theme.palette.grey['900'] } }, t('missions.missionDetails.shiftRoster')),
        React.createElement(Typography, { variant: 'body2', sx: { color: (theme) => theme.palette.grey['700'] } },
            "(",
            `${participantNumber} of ${totalRequiredParticipantNumber}`,
            ")")));
};
